<main id="main-content" class="main-content">
  <h2 class="form-header">2. Authorized and Completed Treatments</h2>
  <span class="gray-text" style="margin-bottom: 10px;"><b>Tip:</b> To expand or collapse all treatment cards,
select “Ctrl” on your keyboard and click over a treatment card.</span>

@for (treatmentType of treatmentTypes; track treatmentType; let i = $index) {
  <div class="forest-container">
    <h2 class="treatment-type" [id]="treatmentType.treatment_type_id">{{ treatmentType.treatment_type}}</h2>
    <mat-accordion [multi]="true" #accordion="matAccordion">
      @for(treatment of treatmentList; track treatment; let j = $index) {
        @if (treatment.treatment.treatment_type_id == treatmentType.treatment_type_id) {
          <mat-expansion-panel
            class="treatment-container" expanded="false" hideToggle (opened)="treatment.open = true"
            (closed)="treatment.open = false" (click)="onTreatmentClick($event, accordion)"
            (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
            <mat-expansion-panel-header>
              <mat-panel-title class="treatment-title">
                @if (treatment.open) {
                  <i class="material-icons green-arrow" role="img">keyboard_arrow_down</i>
                }
                @if (!treatment.open) {
                  <i class="material-icons green-arrow" role="img">chevron_right</i>
                }
                <div class="treatment-title-info">
                  <div>{{treatment.forest_name}}</div>
                  <span class="thin">
                    {{ treatment?.treatment?.treatment_option?.treatment_option }}
                    ({{treatment?.treatment?.treatment_option?.unit_of_measure}})
                    (Spec.{{treatment?.treatment.treatment_specifications[0].specification_number}})
                  </span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <h3>Authorized</h3>
              <div class="whole-line" style="flex-wrap: wrap;">
                <div class="quarter-div">
                  <p class="data-title"># of Units</p>
                  <p class="data-info">{{(treatment.treatment.treatment_specifications[0]?.approved_unit_qty
                    ?? 0) + (treatment.treatment.treatment_specifications[0]?.wo_approved_unit_qty ?? 0)}}
                  </p>
                </div>
                <div class="quarter-div">
                  <p class="data-title">Total ($)</p>
                  <p class="data-info">{{calcTotalAuth(treatment) | currency}}</p>
                </div>
              </div>
              <h3>Completed</h3>
              <div class="whole-line" style="flex-wrap: wrap;">
                <div class="quarter-div">
                  <p class="data-title"># of Units</p>
                  <p class="data-info">{{treatment.form.units}}</p>
                </div>
                <div class="quarter-div">
                  <p class="data-title">Total ($)</p>
                  <p class="data-info">{{calcTotalCompleted(treatment) | currency}}</p>
                </div>
                <div class="quarter-div">
                  <p class="data-title">Date Completed</p>
                  <p class="data-info">{{treatment.form.date_completed | date:"MM/dd/yyyy"}}</p>
                </div>
              </div>
              <div class="whole-line" style="flex-wrap: wrap;">
                <div class="quarter-div">
                  <p class="data-title">Method</p>
                  <p class="data-info">{{treatment.form.method}}</p>
                </div>
                @if (treatment.form.method_id === 0) {
                  <div class="quarter-div">
                    <p class="data-title">Contract ID</p>
                    <p class="data-info">{{treatment.form.contract_id}}</p>
                  </div>
                }
                @if (treatment.form.method_id === 0) {
                  <div class="quarter-div">
                    <p class="data-title">Contract Status</p>
                    <p class="data-info">{{treatment.form.contract_status_id}}</p>
                  </div>
                }
                @if (treatment.form.method_id === 1) {
                  <div class="quarter-div">
                    <p class="data-title">Agreement ID</p>
                    <p class="data-info">{{treatment.form.agreement}}</p>
                  </div>
                }
              </div>
              <div class="text-div">
                <b><span class="red-normal">*</span>Provide a status and major changes or plans for project
              completion </b>
              <br>
                <span class="gray-text">Describe any major changes from request to implementation (i.e. what was
                changed and why) or any plans for project completion for this treatment.</span>
              </div>
              <div class="text" [innerHTML]="customATOB(treatment.form.status_statement || '--')"></div>
            </div>
          </mat-expansion-panel>
        }
      }
    </mat-accordion>
  </div>
}
<div class="forest-container">
  <h2 class="forest-title" id="8">Total</h2>
  <mat-accordion [multi]="true" #accordion="matAccordion">
    <mat-expansion-panel class="treatment-container" expanded="false" hideToggle (opened)="open = true"
      (closed)="open = false" (click)="onTreatmentClick($event, accordion)"
      (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
      <mat-expansion-panel-header>
        <mat-panel-title class="treatment-title">
          @if (open) {
            <i class="material-icons green-arrow" role="img">keyboard_arrow_down</i>
          }
          @if (!open) {
            <i class="material-icons green-arrow" role="img">chevron_right</i>
          }
          <div class="treatment-title-info">
            <div>Total</div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="whole-line" style="flex-wrap: wrap;">
        <div class="total-container">
          <div class="total-header">Authorized</div>
          <div class="total-subcontainer">
            <div class="sub-header"># of Units</div>
            {{totalUnits | number: '1.0-0'}}
          </div>
          <div class="total-subcontainer">
            <div class="sub-header">Total ($)</div>
            {{totalFunding | currency}}
          </div>
        </div>
        <div class="total-container">
          <div class="total-header">Completed</div>
          <div class="total-subcontainer">
            <div class="sub-header"># of Units</div>
            {{totalCompletedUnits() | number: '1.0-0'}}
          </div>
          <div class="total-subcontainer">
            <div class="sub-header">Total ($)</div>
            {{totalCompletedFunding() | currency}}
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
</main>